<template>
  <div class="suggestion">
    <iframe
      src="https://ideas37927earthblox.ideas.aha.io/"
      title="Earth Blox | Earth Blox Feedback Portal"
    ></iframe>
  </div>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 * 
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 * 
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
export default {
  name: "Suggestion",
  created() {
    console.log("Suggestion.vue  created");
  } //ends created
}; // export
</script>

<style scoped lang="scss">
.suggestion {
  height: 100%;
}

.suggestion iframe {
  display: block;
  width: 100%;
  height: calc(100% - 48px);
  position: absolute;
  top: 48px;
  left: 0;
  right: 0;
  border: 0;
}

@media (min-width: 961px) {
  .suggestion iframe {
    height: calc(100% - 64px);
    top: 64px;
  }
}
</style>